class TabBar {
  static CATALOG_ALIAS = 'catalog';
  static WISHLIST_ALIAS = 'wishlist';
  static CART_ALIAS = 'cart';

  static CLASS_NAME = 'tab-bar';
  static TAB_CLASS_NAME = 'tab-bar-item';

  static THEMES = {
    DEFAULT: 'default',
    TRANSPARENT: 'transparent',
  };

  constructor() {
    this.init();
  }

  init() {
    this.$element = document.querySelector(`.${TabBar.CLASS_NAME}`);
    this.$tabs = this.$element.querySelectorAll(`.${TabBar.TAB_CLASS_NAME}`);

    this.$theme = this.$element.dataset.theme;
    this.$active = this.$element.dataset.active;
    this.$selected = this.$active;
    this.$initialTheme = this.$theme;
    this.$isInitialState = true;

    this.initListeners();
  }

  initListeners() {
    this.$tabs.forEach($tab => {
      $tab.addEventListener('click', (event) => {
        const alias = $tab.dataset.alias;

        if (alias === TabBar.CATALOG_ALIAS) {
          // Если происходит клик по табу каталога,
          // отменяем переход по ссылке
          // и триггерим кастомное событие
          event.preventDefault();

          const catalogTabClickEvent = new CustomEvent('catalog-tab-click');
          window.dispatchEvent(catalogTabClickEvent);
        } else
        if (
          this.selected === TabBar.CATALOG_ALIAS &&
          this.$active === alias
        ) {
          // Если открыт каталог, а пользователь кликает на таб
          // активной страницы, то триггерим событие
          event.preventDefault();

          const activeTabClickEvent = new CustomEvent('active-tab-click');
          window.dispatchEvent(activeTabClickEvent);
        }
      });
    });

    // Подписываемся на глобальное событие обновления количества товаров в вишлисте
    // и обновляем бейдж у соответствующего таба
    window.addEventListener('wishlist-count-update', (event) => {
      this.updateTabBadge(TabBar.WISHLIST_ALIAS, event.detail?.value);
    }, false);

    // Подписываемся на глобальное событие обновления количества товаров в корзине
    // и обновляем бейдж у соответствующего таба
    window.addEventListener('cart-count-update', (event) => {
      this.updateTabBadge(TabBar.CART_ALIAS, event.detail?.value);
    }, false);

    // При открытии мобильного меню меняем тему таббара на дефолтную (непрозрачную)
    window.addEventListener('mobile-menu-open', () => {
      this.setDefaultTheme();
      this.selected = TabBar.CATALOG_ALIAS;
    });

    // При закрытии мобильного меню возвращаем исходную тему таббара
    window.addEventListener('mobile-menu-close', () => {
      this.resetTheme();
      this.selected = this.$active;
    });

  }

  setDefaultTheme() {
    this.$isInitialState = false;
    this.theme = TabBar.THEMES.DEFAULT;
  }

  setTransparentTheme() {
    this.$isInitialState = false;
    this.theme = TabBar.THEMES.TRANSPARENT;
  }

  resetTheme() {
    this.$isInitialState = true;
    this.theme = this.$initialTheme;
  }

  updateTabsClassNames() {
    this.$tabs.forEach(tab => {
      const alias = tab.dataset.alias;
      const isSelected = this.selected === alias;
      const selectedClassName = isSelected ? ` ${TabBar.TAB_CLASS_NAME}--active` : '';
      const withBadgeClassName = (
        tab.dataset.badge && tab.dataset.badge > 0
      ) ? ` ${TabBar.TAB_CLASS_NAME}--with-badge` : '';

      tab.className = `${TabBar.TAB_CLASS_NAME} ${TabBar.TAB_CLASS_NAME}--${this.theme} ${TabBar.TAB_CLASS_NAME}--${alias}${selectedClassName}${withBadgeClassName}`;
    });
  }

  /**
   *
   * @param {string} tabAlias
   * @param {string} badgeValue
   */
  updateTabBadge(tabAlias, badgeValue) {
    const currentTab = Array.prototype.find.call(this.$tabs, (tab) => tab.dataset.alias === tabAlias);

    if (!currentTab) {
      return;
    }

    const currentTabBadge = currentTab.querySelector(`.${TabBar.TAB_CLASS_NAME}__badge`);

    currentTab.dataset.badge = badgeValue;

    if (badgeValue > 0) {
      currentTabBadge.innerText = badgeValue;
    }

    this.updateTabsClassNames();
  }

  /**
   *
   * @returns {string}
   */
  get selected() {
    return this.$selected;
  }

  /**
   *
   * @returns {string}
   */
  get theme() {
    return this.$theme;
  }

  /**
   *
   * @param {string} value
   */
  set selected(value) {
    if (this.$selected === value) {
      return;
    }

    this.$selected = value;
    this.updateTabsClassNames();
  }

  /**
   *
   * @param {string} value
   */
  set initialTheme(value) {
    if (!Object.values(TabBar.THEMES).includes(value)) {
      return;
    }

    this.$initialTheme = value;

    if (this.$isInitialState) {
      this.theme = this.$initialTheme;
    }
  }

  /**
   *
   * @param {string} value
   */
  set theme(value) {
    if (
      this.$theme === value ||
      !Object.values(TabBar.THEMES).includes(value)
    ) {
      return;
    }

    this.$theme = value;
    this.$element.className = `${TabBar.CLASS_NAME} ${TabBar.CLASS_NAME}--${this.$theme}`;

    this.updateTabsClassNames();
  }

}

const tabBar = new TabBar();